
export type UpdateUserProfile500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
